var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 440.6078,
    y1: 0,
    x2: 440.6078,
    y2: 881.2156
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DE0E54"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F003D"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.16
    },
    width: 881,
    height: 662,
    xlinkHref: "6A6A2F1EA0A20B7D.png",
    transform: "matrix(1 0 0 1 0.1232 109.3282)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.3,586V295.2c0-25.5,14.4-40.5,38.9-40.5h123c69.9,0,113.7,35.8,113.7,92.8c0,40.7-30.4,74.8-69.9,80.7 v2.1c50.5,3.9,87.7,40.7,87.7,90c0,65.5-49.2,106.5-128.6,106.5H177.2C152.7,626.7,138.3,611.8,138.3,586z M272.1,409.4 c41.5,0,65.2-18.3,65.2-49.8c0-29.9-20.9-46.9-57.2-46.9h-63.9v96.7H272.1z M283.2,568.7c44.9,0,69.1-19.1,69.1-54.7 c0-34.8-25-53.4-70.9-53.4h-65.2v108H283.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M452.1,561.5c-2.6-6.7-4.1-13.9-4.1-20.9c0-20.6,14.2-34.3,34.3-34.3c16,0,26.6,6.2,35.8,22.7 c12.1,28.4,41.2,41.2,76.8,41.2c41.8,0,70.1-20.1,70.1-47.4c0-24.5-17.5-38.4-64.2-48l-39.4-7.7 c-74.2-14.7-110.6-50.3-110.6-105.7c0-68.1,59.3-113.2,142.1-113.2c68.1,0,119.4,28.6,135.9,77.1c1.8,5.2,2.8,10.6,2.8,17.3 c0,18.6-13.4,31.2-33.3,31.2c-17.5,0-28.4-7-37.1-22.9c-12.4-28.1-36.4-39.7-68.3-39.7c-38.4,0-63.9,18-63.9,45.4 c0,22.9,17.8,37.1,61.9,45.9l39.2,8c78.9,15.7,112.9,47.4,112.9,103.9c0,72.7-57,118.6-149.8,118.6 C516.3,632.9,467.1,602.3,452.1,561.5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsIcon);
export default __webpack_public_path__ + "static/media/bs_icon.621891f2b7251f084798dfeefdc5a929.svg";
export { ForwardRef as ReactComponent };